module.exports = __webpack_public_path__ + "img/V7.2789fd3d.png";